// extracted by mini-css-extract-plugin
export default {"loaderCont":"AllChats_loaderCont__X786r","AllChatsContainer":"AllChats_AllChatsContainer__rzjVP","chatCont":"AllChats_chatCont__Tzxto","chatContent":"AllChats_chatContent__bJq6J"};